import { Show } from "solid-js";
import Text from "./Text";
import styles from "./StateDisplay.module.css";

interface StateDisplayProps {
  loading?: boolean;
  empty?: boolean;
  error?: boolean;
  icon?: string;
  message?: string;
  rawMessage?: string;
  helpText?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  onRetry?: () => void;
}

export default function StateDisplay(props: StateDisplayProps) {
  return (
    <div class={`${styles.container} ${props.error ? styles.errorState : ""}`}>
      <Show when={props.loading}>
        <div class={styles.spinner}>
          <i class="fa-solid fa-circle-notch fa-spin" />
        </div>
        <Show when={props.message}>
          <p class={styles.message}><Text val={props.message!} /></p>
        </Show>
      </Show>

      <Show when={!props.loading && (props.empty || props.error)}>
        <Show when={props.icon}>
          <i class={`${props.icon} ${styles.icon}`} />
        </Show>
        <Show when={props.message}>
          <p class={styles.message}><Text val={props.message!} /></p>
        </Show>
        <Show when={props.rawMessage}>
          <p class={styles.message}>{props.rawMessage}</p>
        </Show>
        <Show when={props.helpText}>
          <p class={styles.helpText}><Text val={props.helpText!} /></p>
        </Show>
        <Show when={props.action}>
          <button class={styles.actionBtn} onClick={props.action!.onClick}>
            <Text val={props.action!.label} />
          </button>
        </Show>
        <Show when={props.error && props.onRetry}>
          <button class={styles.retryBtn} onClick={props.onRetry}>
            <i class="fa-solid fa-rotate-right" style="margin-right: 6px" />
            <Text val="STATE_RETRY" />
          </button>
        </Show>
      </Show>
    </div>
  );
}
